import { render, staticRenderFns } from "./MetaIndustryAnalysis.vue?vue&type=template&id=985c1b8c&scoped=true&"
import script from "./MetaIndustryAnalysis.vue?vue&type=script&lang=ts&"
export * from "./MetaIndustryAnalysis.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985c1b8c",
  null
  
)

export default component.exports